export const ECHION_BASE_STATS = {
  name: "에키온",
  weaponType: "VF의수",

  baseStats: {
    level1: {
      hp: 955,
      attackPower: 35,
      defense: 50,
    },
    level20: {
      hp: 2703,
      attackPower: 131,
      defense: 110,
    },
  },

  growthPerLevel: {
    hp: 92,
    attackPower: 96 / 19,
    defense: 60 / 19,
  },

  weaponMastery: {
    skillAmp: {
      level1: 3,
      level20: 60,
      growthPerLevel: 3,
      unit: "%",
    },
    basicAttackAmp: {
      level1: 1,
      level20: 20,
      growthPerLevel: 1,
      unit: "%",
    },
  },
};
